import 'promise-polyfill/src/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import {ecsHelper} from './helpers/EcsHelper';
import config from './config';
import { logger } from './helpers/LoggerHelper';

logger.init();
ecsHelper.loadConfig((settings) => {
    config.ecs = settings;
    ReactDOM.render(<App />, document.getElementById('root'));
});


